import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Alert,
  Box
} from '@mui/material';
import { RecordVoiceOver, Warning } from '@mui/icons-material';

const ConsentDialog = ({ open, onAccept, onDecline }) => {
  const [consentChecked, setConsentChecked] = useState(false);

  const handleAccept = () => {
    if (consentChecked) {
      onAccept();
      setConsentChecked(false);
    }
  };

  const handleDecline = () => {
    onDecline();
    setConsentChecked(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleDecline}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RecordVoiceOver color="primary" />
        Recording Consent Required
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" icon={<Warning />} sx={{ mb: 2 }}>
          This meeting will be recorded
        </Alert>
        
        <Typography variant="body1" paragraph>
          By proceeding, you acknowledge and consent that:
        </Typography>
        
        <Box component="ul" sx={{ pl: 2, mb: 2 }}>
          <Typography component="li" variant="body2" paragraph>
            This call/meeting will be recorded and stored securely
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            The recording may include your voice and any shared audio
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            The recording will be processed and may be transcribed
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            The recording is stored within your organization and subject to your organization's data retention policies
          </Typography>
          <Typography component="li" variant="body2">
            You may request deletion of the recording at any time
          </Typography>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={consentChecked}
              onChange={(e) => setConsentChecked(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Typography variant="body2">
              I understand and consent to this meeting being recorded
            </Typography>
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDecline} color="inherit">
          Decline & Exit
        </Button>
        <Button
          onClick={handleAccept}
          variant="contained"
          color="primary"
          disabled={!consentChecked}
        >
          Accept & Start Recording
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentDialog;
